import { forwardRef } from "react";
import { TransitionProps } from "@mui/material/transitions";
import { Dialog, DialogContent, Zoom, useTheme } from "@mui/material";
import Iconify from "~src/components/Iconify";
import { AdData, MapOfBrands } from "~src/types/brandMapping";
import { brandConfig } from "../../utils";
// Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Zoom in={props.in} ref={ref} {...props} />;
});

type PropsType = {
  open: boolean;
  close: () => void;
  data: AdData | undefined;
  selectedBrand: MapOfBrands | undefined;
};

export function AdImagePopup({ open, close, data, selectedBrand }: PropsType) {
  const theme = useTheme();
  if (!data) return null;

  return (
    <Dialog
      open={open}
      onClose={close}
      TransitionComponent={Transition}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "30%",
          maxWidth: "600px",
        },
        [theme.breakpoints.up("md")]: { px: 4 },
        [theme.breakpoints.down("sm")]: { px: 1 },
      }}
    >
      <DialogContent
        sx={{
          position: "relative",
          justifyContent: "center",
          alignItems: "center",
          p: 1,
        }}
      >
        <Swiper
          loop={false}
          centeredSlides={true}
          slidesPerView={1}
          pagination={false}
          navigation={{
            nextEl: ".button-next-slide",
            prevEl: ".button-prev-slide",
          }}
          modules={[Pagination, Navigation]}
          className="mySwiper"
          style={{ position: "relative" }}
        >
          {brandConfig(selectedBrand)?.adImageUrls?.map((item) => {
            if (!item.ad_image && !item.ad_video) return null;

            return (
              <SwiperSlide key={item.page_id}>
                {item.ad_video ? (
                  <video
                    style={{
                      width: "100%",
                      height: "auto",
                      maxHeight: "80vh",
                      objectFit: "contain",
                      display: "block",
                      margin: "0 auto",
                    }}
                    poster={item.ad_image}
                    onError={(e) => {
                      //@ts-ignore
                      e.target.poster =
                        "/assets/illustrations/illustration_no_product_image.png";
                    }}
                  >
                    <source src={item.ad_video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <img
                    src={item.ad_image}
                    alt=""
                    style={{
                      width: "100%",
                      height: "auto",
                      maxHeight: "80vh",
                      objectFit: "contain",
                      display: "block",
                      margin: "0 auto",
                    }}
                    loading="lazy"
                    onError={(e) => {
                      //@ts-ignore
                      e.target.src =
                        "/assets/illustrations/illustration_no_product_image.png";
                    }}
                  />
                )}
              </SwiperSlide>
            );
          })}

          <div
            className="button-prev-slide"
            style={{
              position: "absolute",
              top: "50%",
              left: "10px",
              transform: "translateY(-50%)",
              zIndex: 4,
              cursor: "pointer",
            }}
          >
            <Iconify
              icon={"ooui:previous-ltr"}
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: "white",
                borderRadius: "50%",
              }}
            />
          </div>

          <div
            className="button-next-slide"
            style={{
              position: "absolute",
              top: "50%",
              right: "10px",
              transform: "translateY(-50%)",
              zIndex: 4,
              cursor: "pointer",
            }}
          >
            <Iconify
              icon={"ooui:previous-rtl"}
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: "white",
                borderRadius: "50%",
              }}
            />
          </div>
        </Swiper>
      </DialogContent>
    </Dialog>
  );
}
